import { ClickableIcon } from "@portal/components/primitives";
import { useCallback, useEffect, useRef, useState } from "react";
import { withPlainCitations } from "./assistantCitations";
import { assistantCopiedLabel, assistantCopyAnswerLabel } from "./assistantCopy";
import { withoutChartBlocks } from "./chart/assistantChartFence";

const COPIED_RESET_MS = 1200;

/** Copies an answer out of the panel, confirming with a transient check. */
export const AdminAssistantCopyAnswer = ({ text }: { text: string }) => {
	const [copied, setCopied] = useState(false);
	const resetTimeout = useRef<ReturnType<typeof setTimeout> | undefined>(undefined);

	useEffect(() => () => clearTimeout(resetTimeout.current), []);

	const copy = useCallback(async () => {
		try {
			await navigator.clipboard.writeText(withPlainCitations(withoutChartBlocks(text)));
		} catch {
			return;
		}
		setCopied(true);
		clearTimeout(resetTimeout.current);
		resetTimeout.current = setTimeout(() => setCopied(false), COPIED_RESET_MS);
	}, [text]);

	const label = copied ? assistantCopiedLabel : assistantCopyAnswerLabel;

	return (
		<ClickableIcon
			aria-label={label}
			color={copied ? "confirm" : "tertiary"}
			data-testid="assistant-copy-answer"
			onClick={() => void copy()}
			size="mini"
			tooltip={label}
			type={copied ? "check" : "clipboard"}
		/>
	);
};
